import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import filesize from "filesize";
import { Formik, FieldArray } from "formik";
import moment from "moment";
import map from "lodash.map";
import filter from "lodash.filter";
import isEmpty from "lodash.isempty";
import isEqual from "lodash.isequal";
import Immutable from "seamless-immutable";
import Form from "react-bootstrap/lib/Form";
import { Button } from "../../Button";
import { OneFormConsultationFormContainer } from "./OneFormConsultationFormContainer";
import { ProjectCard } from "./ProjectCard";
import {
  ProjectStatus,
  ProjectType,
  ProjectMode,
  ConsultationFormType,
  DistrictDropdownOption,
} from "../../../utils/enums";
import { Loader } from "../../Loader";
import { ButtonLoader } from "../../ButtonLoader";
import {
  OneFormBudgetVoteValidationSchema,
  OneFormProjectVoteValidationSchema,
} from "../../../validators";
import { Attachment } from "../../Attachment";

export class PreviewOneFormProjectCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: {
        act: true,
        survey: false,
        probe: false,
      },
      agreementAccepted: props.agreementAccepted || false,
      ...this.calculateUserVote(),
    };
    this.projectCard = null;

    this.onChangeAgreementAccepted = (e) => {
      this.setState({
        agreementAccepted: e.target.checked,
      });
    };

    this.scrollToAgreement = this.scrollToAgreement.bind(this);

    this.toggleOpen = (e, name) => {
      e.preventDefault();
      this.setState({
        opened: Immutable.merge(this.state.opened, {
          [name]: !this.state.opened[name],
        }),
      });
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.agreementAccepted !== this.props.agreementAccepted) {
      this.setState({
        agreementAccepted: this.props.agreementAccepted,
      });
    }
    if (!isEqual(prevProps.consultationForms, this.props.consultationForms)) {
      this.setState({
        ...this.calculateUserVote(),
      });
    }
  }

  canSetProjectOpinion() {
    return false;
  }

  calculateUserVote() {
    if (
      isEmpty(
        filter(
          this.props.consultationForms,
          (form) => form.type !== ConsultationFormType.Comment
        )
      )
    ) {
      return {
        availableVoteForms: 0,
        voteForms: 0,
      };
    }

    return {
      availableVoteForms:
        filter(
          this.props.consultationForms,
          (form) => form.type !== ConsultationFormType.Comment
        ).length || 0,
      voteForms:
        filter(
          this.props.consultationForms,
          (form) => form.type !== ConsultationFormType.Comment && form.voted
        ).length || 0,
    };
  }

  renderAttachmentsIcon(type) {
    switch (type) {
      case "application/pdf": {
        return (
          <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
      default: {
        return (
          <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
    }
  }

  renderAttachments(attachments) {
    return (
      <Fragment>
        <div className="consultations__title margin-top-25 margin-bottom-15">
          Załączniki
        </div>
        <div className="attachments-list">
          {map(attachments, (attachment) => (
            <Attachment
              key={attachment.id}
              {...{
                attachment,
                url: `/api/attachments/${attachment.id}`,
              }}
            >
              {this.renderAttachmentsIcon(attachment.contentType)}
            </Attachment>
          ))}
        </div>
      </Fragment>
    );
  }

  renderResultAttachments(resultAttachments) {
    return (
      <Fragment>
        <div className="consultations__title margin-top-25 margin-bottom-15">
          Opublikowane wyniki
        </div>
        <div className="attachments-list">
          {map(resultAttachments, (attachment) => (
            <Attachment
              key={attachment.id}
              {...{
                attachment,
                url: `/api/attachments/${attachment.id}`,
              }}
            >
              {this.renderAttachmentsIcon(attachment.contentType)}
            </Attachment>
          ))}
        </div>
      </Fragment>
    );
  }
  scrollToAgreement() {
    this.projectCard.scrollToAgreement();
  }

  addDefaultAnswers(project) {
    let newConsultationForms = map(
      project.consultationForms,
      (consultationForm) => {
        let newCategories = map(consultationForm.categories, (category) => {
          let newQuestions = map(category.questions, (question) => {
            question.answers = isEmpty(question.answers)
              ? [
                  {
                    id: 0,
                    questionId: question.id,
                    userId: this.props.loggedUserId,
                    categoryId: category.id,
                    answerOptions: [
                      {
                        id: 0,
                        comment: "",
                        openText: 0,
                        openDate: null,
                        questionOptionId: 0,
                        questionMatrixValueId: 0,
                      },
                    ],
                  },
                ]
              : question.answers;

            return question;
          });

          category.questions = newQuestions;
          return category;
        });

        consultationForm.categories = newCategories;
        return consultationForm;
      }
    );

    project.consultationForms = newConsultationForms;
    return project;
  }

  getConsultationFormValidationSchema() {
    return this.props.type === ProjectType.PublicBudget
      ? OneFormBudgetVoteValidationSchema
      : OneFormProjectVoteValidationSchema;
  }

  render() {
    const {
      isAuth,
      isProjectLoading,
      isOnlyOneOffice,
      loggedOfficeId,
      loggedDistrictId,
      opinionExecuting,
      voteExecuting,
      addCommentOpinion,
      removeCommentOpinion,
      saveComment,
      addProjectOpinion,
      removeProjectOpinion,
      saveAnswers,
      onCancel,
      ...project
    } = this.props;
    const {
      disabled,
      type,
      attachments,
      resultAttachments,
      status,
      mode,
      modeName,
      officeId,
      officeName,
      resultSummary,
      agreementAccepted,
      agreementHistory,
      externalSystemAddress,
    } = this.props;
    const {
      opened,
      availableVoteForms,
      voteForms,
      agreementAccepted: stateAgreementAccepted,
    } = this.state;
    let newProject = Immutable.asMutable(project, { deep: true });
    if (type === ProjectType.PublicBudget) {
      newProject = this.addDefaultAnswers(newProject);
    }
    const consultationFormIds = map(
      newProject.consultationForms,
      (cf) => cf.id
    );
    const isVoteButtonEnabled =
      !this.props.disabled &&
      (this.props.onlyForLegalAge ? this.props.isLegalAgeUser : true);
    const isExecuting = voteExecuting.some((consultationFormId) =>
      consultationFormIds.includes(consultationFormId)
    );
    const validationSchema = this.getConsultationFormValidationSchema();
    const url = externalSystemAddress
      ? new URL(externalSystemAddress)
      : { origin: "http://brak-ustawionego-adresu.pl" };

    return (
      <Fragment>
        {isProjectLoading && <Loader loading={isProjectLoading} />}
        {!isProjectLoading && (
          <Formik
            enableReinitialize={stateAgreementAccepted === agreementAccepted}
            initialValues={newProject}
            validationSchema={validationSchema}
            render={({
              touched,
              values,
              handleChange,
              handleBlur,
              isValid,
              errors,
              setFieldValue,
              isSubmitting,
              setSubmitting,
            }) => (
              <Form noValidate method="post">
                <div id="content" className="container consultations">
                  <ProjectCard
                    ref={(ref) => (this.projectCard = ref)}
                    {...this.props}
                    canSetProjectOpinion={this.canSetProjectOpinion()}
                    disabled={true}
                    addProjectOpinion={(id, type) =>
                      this.props.addProjectOpinion(id, type)
                    }
                    removeProjectOpinion={(id) =>
                      this.props.removeProjectOpinion(id)
                    }
                    opinionExecuting={this.props.opinionExecuting}
                    onChangeAgreementAccepted={this.onChangeAgreementAccepted}
                    availableVoteForms={availableVoteForms}
                    voteForms={voteForms}
                    agreementAccepted={this.props.agreementAccepted}
                    actualAgreementAccepted={this.state.agreementAccepted}
                    agreementAcceptedRequired={!isEmpty(agreementHistory)}
                    scrollToAgreement={this.scrollToAgreement}
                  />
                  {loggedDistrictId === DistrictDropdownOption.NotSetted &&
                    type === ProjectType.PublicBudget && (
                      <div class="bag bag--warning d-block m-r4 m-l4">
                        Aby wziąć udział w głosowaniach na projekty budżetu
                        obywatelskiego przejdź do edycji konta na portalu EBOI{" "}
                        <a
                          className="link link--white"
                          href={url.origin}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          ({url.origin})
                        </a>
                        , przypisz odpowiedni obszar w sekcji Dane mieszkańca, a
                        następnie zaloguj się ponownie.
                      </div>
                    )}
                  {!isEmpty(values.consultationForms) && (
                    <div
                      className={`consultation__fields${
                        this.props.type === ProjectType.PublicBudget
                          ? " consultation__fields--no-top-padding"
                          : ""
                      }`}
                    >
                      <FieldArray
                        id="consultationForms"
                        name="consultationForms"
                        render={(_) => (
                          <OneFormConsultationFormContainer
                            disabled={true}
                            loggedUserId={this.props.loggedUserId}
                            projectType={this.props.type}
                            items={values.consultationForms}
                            agreementAccepted={this.state.agreementAccepted}
                            agreementHistory={agreementHistory}
                            voteExecuting={this.props.voteExecuting}
                            isLegalAgeUser={this.props.isLegalAgeUser}
                            onlyForLegalAge={this.props.onlyForLegalAge}
                            isOnlyOneConsultationForms={
                              this.props.consultationForms.length > 0 &&
                              this.props.consultationForms.length === 1
                            }
                            isAuth={isAuth}
                            projectStatus={status}
                            mode={mode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            isPreview={this.props.isPreview}
                          />
                        )}
                      />
                    </div>
                  )}
                  {attachments &&
                    attachments.length > 0 &&
                    type === ProjectType.Consultation && (
                      <div className="consultations__item">
                        <div className="consultations__body">
                          <div className="consultations__item">
                            {this.renderAttachments(attachments)}
                          </div>
                        </div>
                      </div>
                    )}
                  {attachments &&
                    attachments.length > 0 &&
                    type !== ProjectType.Consultation &&
                    this.renderAttachments(attachments)}

                  {resultAttachments &&
                    resultAttachments.length > 0 &&
                    type === ProjectType.Consultation && (
                      <div className="consultations__item">
                        <div className="consultations__body">
                          <div className="consultations__item">
                            {this.renderResultAttachments(resultAttachments)}
                          </div>
                        </div>
                      </div>
                    )}
                  {resultAttachments &&
                    resultAttachments.length > 0 &&
                    type !== ProjectType.Consultation &&
                    this.renderResultAttachments(resultAttachments)}

                  <hr />
                </div>
              </Form>
            )}
          />
        )}
      </Fragment>
    );
  }
}

PreviewOneFormProjectCard.defaultProps = {
  externalSystemAddress: "",
  commentCount: 0,
  consultationTitle: "",
  dateFrom: moment().format("YYYY-MM-DD"),
  dateTo: moment().format("YYYY-MM-DD"),
  description: "",
  disabled: false,
  loggedUserId: 0,
  id: 0,
  isAuth: false,
  modeName: "",
  moderatorName: "",
  shortDescription: "",
  statusName: "",
  thematicAreaName: "",
  title: "",
  type: 0,
  agreementHistory: null,
  agreementAccepted: false,
  opinionExecuting: [],
  voteExecuting: [],

  addCommentOpinion: Function.prototype,
  addProjectOpinion: Function.prototype,
  onCancel: Function.prototype,
  removeCommentOpinion: Function.prototype,
  removeProjectOpinion: Function.prototype,
  saveAnswers: Function.prototype,
  saveComment: Function.prototype,
};
